import React from "react";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import Button from "components/Elements/Button/Button.js";
import EmbedErrorsModal from "components/Pages/Uploader/ModalsAndPopups/EmbedErrorsModal.js";
import qq from "fine-uploader/lib/core/s3.js";
import queryString from "query-string";
import Icon from "components/Elements/Icon/Icon.tsx";
import WrongFilesFormatModal from "components/Pages/Uploader/ModalsAndPopups/WrongFilesFormatModal.tsx";
import { beforeUploadAction } from "components/Pages/Home/Helpers/uploaderAPI.js";
import { DefaultContainerNoClose } from "components/Structure/ModalManager/DefaultContainer.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useCookie } from "contexts/cookieContext/cookieContext.js";
import { useLocation } from "react-router-dom";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { validateEmbedFormats } from "components/Reusable/EmbedFormTemplate/Helpers/ValidationFunctions.js";

const UploaderSendComponent = ({ embedDesign }) => {
  const {
    uploaderGetFiles,
    setUploading,
    setHideSubmit,
    getIsUppy,
    getSize,
    getUploadId,
    getMailId,
    uplaoderStartUpload,
    uploaderSetMeta,
    uploaderRemoveFile,
  } = useUploader();
  const location = useLocation();
  const { setCookies, getCookie, removeCookies } = useCookie();

  const { getTextByKey, getHtmlByKey, getLanguageCulture } = useContent();

  const { setModal } = useModal();

  const { getUserData } = useUser();

  const { addToast } = useToasts();

  const handleWrongFilesFormat = async (resData, filesList) => {
    if (!resData) return;
    if (resData.Embed_Dynamic_Formats) {
      const embedFormats = resData.Embed_Dynamic_Formats.toLowerCase();
      let wrongFiles = null;
      if (resData.Embed_Dynamic_Formats_Action === "Only") {
        wrongFiles = filesList.filter(
          (file) => !embedFormats.includes(file.file.extension.toLowerCase())
        );
      }
      if (resData.Embed_Dynamic_Formats_Action === "Exclude") {
        wrongFiles = filesList.filter((file) =>
          embedFormats.includes(file.file.extension.toLowerCase())
        );
      }
      if (wrongFiles?.length > 0) {
        const filesNames = wrongFiles.map((file) => file.file.name);
        wrongFiles.forEach((file) => {
          uploaderRemoveFile(file.id);
        });
        setModal({
          modal: WrongFilesFormatModal,
          container: DefaultContainerNoClose,
          modalSize: "full-modal",
          props: {
            filesNames,
            culture: resData.Embed_Dynamic_Culture,
            callback: handleSend,
          },
        });
        return true;
      }
    }
  };

  const handleSend = async () => {
    uploaderSetMeta({
      getUniqueId: qq.getUniqueId,
      addWaterMark: false,
      isEmbed: true,
    });

    const res = await apiRequest(
      "EmbedDynamics",
      "ReactGetEmbedDynamicFormByEncryptedMailID",
      {
        encryptedMailId: getMailId(),
      }
    );

    let foramtsList = null;

    const filesList = uploaderGetFiles();

    if (filesList.length === 0) return;

    const formatsResult = validateEmbedFormats({
      formatsAction: res.data?.Embed_Dynamic_Formats_Action,
      formats: res.data?.Embed_Dynamic_Formats,
      files: filesList,
    });

    if (formatsResult[0]) {
      foramtsList = formatsResult[1];
    }

    const embedModalHandler = (result) => {
      setHideSubmit(false);
      setUploading(false);
      setModal({
        modal: EmbedErrorsModal,
        container: DefaultContainerNoClose,
        modalSize: "full-modal",
        props: {
          typeError: result,
          embedDetails: res.data,
        },
      });
    };

    const existWrongFiles = await handleWrongFilesFormat(res.data, filesList);
    if (existWrongFiles) return;

    // doing request to server to set all settings relevant to this mail and get confirmation that uploading allowed
    // if yes it will start upload
    const totalSize = getIsUppy()
      ? getSize()
      : filesList.reduce((acc, file) => acc + file.size, 0);

    const submitRes = await beforeUploadAction({
      files: filesList,
      uploadId: getUploadId(),
      lang: getLanguageCulture(),
      userMail: getUserData().UserName,
      totalSize: totalSize,
      uplaoderStartUpload: () => {
        document.title = `${getHtmlByKey("uploading-title")}: 0%`;
        uplaoderStartUpload();
        // Only set these states after successful validation and upload start
        setUploading(true);
        setHideSubmit(true);
      },
      code: null,
      foramtsList,
      isEmbed: true,
      embedModalHandler,
    });

    if (submitRes?.status === "error") {
      addToast(getTextByKey("uploading-error-title"), {
        appearance: "error",
      });
      // Make sure states are reset on error
      setUploading(false);
      setHideSubmit(false);
    } else {
      //if the form is picker
      const isPickerForm = res.data.IsPickerForm;
      if (isPickerForm) {
        const searchParams = queryString.parse(location.search);
        //if the form is picker
        const tidParam = searchParams["tid"];
        const cookieName = `JMPicker-${tidParam}`;
        //check if exists cookie and if exists, remove it
        if (getCookie(cookieName)) {
          removeCookies(cookieName);
        }
        //set cookie `JMPicker-{encryptedPickerMail}` and value is "UPLOADING" for 24 hours
        setCookies(cookieName, "UPLOADING", {
          path: "/",
          domain: ".jumbomail.me",
          expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        });
      }
    }
  };

  return (
    <div className="send-files">
      <Button
        onClick={handleSend}
        style={
          embedDesign.buttonsColor
            ? {
                backgroundColor: embedDesign.buttonsColor,
              }
            : null
        }
      >
        {getTextByKey("send")}
        <Icon name="arrow-back" white />
      </Button>
    </div>
  );
};

export default UploaderSendComponent;
